import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import salonApiController from "services/salon.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const salonErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const SalonDetailApi = createAsyncThunk("salon/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const IsExistApi = createAsyncThunk("salon/isexist", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .isexist(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "isexist"))
      .catch((error) => HandleError(thunkAPI, error, "isexist"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClosedDateApi = createAsyncThunk("salon/closeddateapi", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .closeddate(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "closeddateapi"))
      .catch((error) => HandleError(thunkAPI, error, "closeddateapi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const FeatureAccessApi = createAsyncThunk("salon/salonfeatureaccess", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .featureaccess(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "salonfeatureaccess"))
      .catch((error) => HandleError(thunkAPI, error, "salonfeatureaccess"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ActivePlanApi = createAsyncThunk("salon/salonactiveplan", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .activeplan(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "salonactiveplan"))
      .catch((error) => HandleError(thunkAPI, error, "salonactiveplan"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


export const CountableApi = createAsyncThunk("salon/countable", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .countable(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "countable"))
      .catch((error) => HandleError(thunkAPI, error, "countable"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const MailChimpSubscriptionApi = createAsyncThunk("salon/mailchimpsubscribe", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .mailchimpsubscribe(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "salonmailchimpsubscribe"))
      .catch((error) => HandleError(thunkAPI, error, "salonmailchimpsubscribe"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const EmptySmsAlertApi = createAsyncThunk("salon/smsalert", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .smsalert(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "smsalert"))
      .catch((error) => HandleError(thunkAPI, error, "smsalert"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const OnlineVoucherSettingsUpdateApi = createAsyncThunk("salon/onlinevouchersettings", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonApiController
      .onlineVoucherSettingsUpdate(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "onlinevouchersettings"))
      .catch((error) => HandleError(thunkAPI, error, "onlinevouchersettings"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const CustomerPortalSettingsUpdateApi = createAsyncThunk("salon/customerportalsettings", async (formValues, thunkAPI) => {
  try {
    return await salonApiController
      .customerPortalSettingsUpdate(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "customerportalsettings"))
      .catch((error) => HandleError(thunkAPI, error, "customerportalsettings"));
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SmsAlertSettingsUpdateApi = createAsyncThunk("salon/smsalertsettings", async (formValues, thunkAPI) => {
  try {
    return await salonApiController
      .smsAlertSettingsUpdate(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "smsalertsettings"))
      .catch((error) => HandleError(thunkAPI, error, "smsalertsettings"));
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isDetailData: "",
  isDetailDataError: "",
  isExistError: { email: "", business_name: "", business_phone_number: "" },
  isExistApi: "",
  isExistApiError: "",
  isClosedDate: [],
  isClosedDateError: "",
  isFeatureAccess: [],
  isFeatureAccessError: "",
  isActivePlan: "",
  isActivePlanError: "",
  isUpgradePlanModal: "",
  isComingSoonAlertModal:"",
  isCountable:"",
  isCountableError: "",
  isSmsAlertData:"",
  isSmsAlertDataError: "",
  isMailChimpSubscriptionData: "",
  isMailChimpSubscriptionError: "",
  isOnlineVoucherSettingsData: "",
  isOnlineVoucherSettingsError: "",
  isCustomerPortalSettingsData: "",
  isCustomerPortalSettingsError: "",
  isSmsAlertSettingsData: "",
  isSmsAlertSettingsError: "",
  isApiStatus: {
    SalonDetailApi: "",
    IsExistApi: "",
    ClosedDateApi: "",
    FeatureAccessApi: "",
    ActivePlanApi: "",
    CountableApi:"",
    MailChimpSubscriptionApi:"",
    EmptySmsAlertApi:"",
    OnlineVoucherSettingsUpdateApi:"",
    CustomerPortalSettingsUpdateApi:"",
    SmsAlertSettingsUpdateApi:""
  },
};

const salonSlice = createSlice({
  name: "salon",
  initialState,
  reducers: {
    reset: () => initialState,
    ExistError: (state, action) => {
      state.isExistError = { ...state.isExistError, ...action.payload };
    },
    UpgradePlanModal: (state, action) => {
      state.isUpgradePlanModal = action.payload;
    },
    ComingSoonAlertModal: (state, action) => {
      state.isComingSoonAlertModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(SalonDetailApi.pending, (state) => {
      state.isDetailDataError = "";
      state.isApiStatus = { ...state.isApiStatus, SalonDetailApi: "loading" };
    })
    .addCase(SalonDetailApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonDetailApi: "succeeded" };
      state.isDetailData = action.payload;
      state.isDetailDataError = "";
    })
    .addCase(SalonDetailApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonDetailApi: "failed" };
      state.isDetailDataError = salonErrorMessage(action, "Unable to load salon details.");
    })
    .addCase(IsExistApi.pending, (state) => {
      state.isExistApiError = "";
      state.isApiStatus = { ...state.isApiStatus, IsExistApi: "loading" };
    })
    .addCase(IsExistApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, IsExistApi: "succeeded" };
      state.isExistApi = action.payload;
      state.isExistApiError = "";
    })
    .addCase(IsExistApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, IsExistApi: "failed" };
      state.isExistApiError = salonErrorMessage(action, "Unable to check salon availability.");
    })
    .addCase(ClosedDateApi.pending, (state) => {
      state.isClosedDateError = "";
      state.isApiStatus = { ...state.isApiStatus, ClosedDateApi: "loading" };
    })
    .addCase(ClosedDateApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, ClosedDateApi: "succeeded" };
      state.isClosedDate = action.payload;
      state.isClosedDateError = "";
    })
    .addCase(ClosedDateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, ClosedDateApi: "failed" };
      state.isClosedDateError = salonErrorMessage(action, "Unable to load closed dates.");
    })
    .addCase(FeatureAccessApi.pending, (state) => {
      state.isFeatureAccessError = "";
      state.isApiStatus = { ...state.isApiStatus, FeatureAccessApi: "loading" };
    })
    .addCase(FeatureAccessApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, FeatureAccessApi: "succeeded" };
      state.isFeatureAccess = action.payload;
      state.isFeatureAccessError = "";
    })
    .addCase(FeatureAccessApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, FeatureAccessApi: "failed" };
      state.isFeatureAccessError = salonErrorMessage(action, "Unable to load feature access.");
    })
    .addCase(ActivePlanApi.pending, (state) => {
      state.isActivePlanError = "";
      state.isApiStatus = { ...state.isApiStatus, ActivePlanApi: "loading" };
    })
    .addCase(ActivePlanApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, ActivePlanApi: "succeeded" };
      state.isActivePlan = action.payload;
      state.isActivePlanError = "";
    })
    .addCase(ActivePlanApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, ActivePlanApi: "failed" };
      state.isActivePlanError = salonErrorMessage(action, "Unable to load the active plan.");
    })
    .addCase(CountableApi.pending, (state) => {
      state.isCountableError = "";
      state.isApiStatus = { ...state.isApiStatus, CountableApi: "loading" };
    })
    .addCase(CountableApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, CountableApi: "succeeded" };
      state.isCountable = action.payload;
      state.isCountableError = "";
    })
    .addCase(CountableApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, CountableApi: "failed" };
      state.isCountableError = salonErrorMessage(action, "Unable to load salon counts.");
    })
    .addCase(MailChimpSubscriptionApi.pending, (state) => {
      state.isMailChimpSubscriptionError = "";
      state.isApiStatus = { ...state.isApiStatus, MailChimpSubscriptionApi: "loading" };
    })
    .addCase(MailChimpSubscriptionApi.fulfilled, (state, action) => {
      state.isMailChimpSubscriptionData = action.payload;
      state.isMailChimpSubscriptionError = "";
      state.isApiStatus = { ...state.isApiStatus, MailChimpSubscriptionApi: "succeeded" };
    })
    .addCase(MailChimpSubscriptionApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, MailChimpSubscriptionApi: "failed" };
      state.isMailChimpSubscriptionError = salonErrorMessage(action, "Unable to update Mailchimp subscription.");
    })
    .addCase(EmptySmsAlertApi.pending, (state) => {
      state.isSmsAlertDataError = "";
      state.isApiStatus = { ...state.isApiStatus, EmptySmsAlertApi: "loading" };
    })
    .addCase(EmptySmsAlertApi.fulfilled, (state, action) => {
      state.isSmsAlertData = action.payload;
      state.isSmsAlertDataError = "";
      state.isApiStatus = { ...state.isApiStatus, EmptySmsAlertApi: "succeeded" };
    })
    .addCase(EmptySmsAlertApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, EmptySmsAlertApi: "failed" };
      state.isSmsAlertDataError = salonErrorMessage(action, "Unable to load SMS balance.");
    })
    .addCase(OnlineVoucherSettingsUpdateApi.pending, (state) => {
      state.isOnlineVoucherSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, OnlineVoucherSettingsUpdateApi: "loading" };
    })
    .addCase(OnlineVoucherSettingsUpdateApi.fulfilled, (state, action) => {
      state.isOnlineVoucherSettingsData = action.payload;
      state.isOnlineVoucherSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, OnlineVoucherSettingsUpdateApi: "succeeded" };
    })
    .addCase(OnlineVoucherSettingsUpdateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, OnlineVoucherSettingsUpdateApi: "failed" };
      state.isOnlineVoucherSettingsError = salonErrorMessage(action, "Unable to update online voucher settings.");
    })
    .addCase(CustomerPortalSettingsUpdateApi.pending, (state) => {
      state.isCustomerPortalSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, CustomerPortalSettingsUpdateApi: "loading" };
    })
    .addCase(CustomerPortalSettingsUpdateApi.fulfilled, (state, action) => {
      state.isCustomerPortalSettingsData = action.payload;
      state.isCustomerPortalSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, CustomerPortalSettingsUpdateApi: "succeeded" };
    })
    .addCase(CustomerPortalSettingsUpdateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, CustomerPortalSettingsUpdateApi: "failed" };
      state.isCustomerPortalSettingsError = salonErrorMessage(action, "Unable to update customer portal settings.");
    })
    .addCase(SmsAlertSettingsUpdateApi.pending, (state) => {
      state.isSmsAlertSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, SmsAlertSettingsUpdateApi: "loading" };
    })
    .addCase(SmsAlertSettingsUpdateApi.fulfilled, (state, action) => {
      state.isSmsAlertSettingsData = action.payload;
      state.isSmsAlertSettingsError = "";
      state.isApiStatus = { ...state.isApiStatus, SmsAlertSettingsUpdateApi: "succeeded" };
    })
    .addCase(SmsAlertSettingsUpdateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SmsAlertSettingsUpdateApi: "failed" };
      state.isSmsAlertSettingsError = salonErrorMessage(action, "Unable to update SMS alert settings.");
    });
  },
});
// Action creators are generated for each case reducer function
export const { reset, ExistError, UpgradePlanModal,ComingSoonAlertModal } = salonSlice.actions;
export default salonSlice.reducer;
